module.exports = __webpack_public_path__ + "static/15_PayPal-cbf8ed5543ad7ccf31a4e5e4cb2999f3.png";